import _ from "lodash";
import { Contract } from "pages/Product/FeaturesSection/Contract";
import { Deliverable } from "pages/Product/FeaturesSection/Deliverable";
import { Feedback } from "pages/Product/FeaturesSection/Feedback";
import { Inquiry } from "pages/Product/FeaturesSection/Inquiry";
import { Invoice } from "pages/Product/FeaturesSection/Invoice";
import { Meeting } from "pages/Product/FeaturesSection/Meeting";
import { Navigation } from "pages/Product/FeaturesSection/Navigation";
import { Notification } from "pages/Product/FeaturesSection/Notification";
import { Roadmap } from "pages/Product/FeaturesSection/Roadmap";
import React, { useEffect, useState } from "react";

const FeaturesSectionDataComponent = "features-section";

export function FeaturesSection() {
  const [navigationVisible, setNavigationVisible] = useState<boolean>(false);

  useEffect(() => {
    const html = document.querySelector("html");
    if (html) {
      html.classList.add("scroll-snap");
    }

    return () => {
      if (html) {
        html.classList.remove("scroll-snap");
      }
    };
  }, []);

  useEffect(() => {
    const heroSection = document.querySelector(
      `[data-component="${FeaturesSectionDataComponent}"]`
    );

    const debouncedSetNavigationVisible = _.debounce(
      (isIntersecting: boolean) => {
        setNavigationVisible(isIntersecting);
      },
      50,
      { trailing: true }
    );

    const observer = new IntersectionObserver(
      ([entry]) => {
        debouncedSetNavigationVisible(entry.isIntersecting);
      },
      {
        threshold: 0.08,
      }
    );

    if (heroSection) {
      observer.observe(heroSection);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div data-component={FeaturesSectionDataComponent}>
      <Inquiry />
      <Meeting />
      <Contract />
      <Invoice />
      <Roadmap />
      <Deliverable />
      <Feedback />
      <Notification />
      <Navigation visible={navigationVisible} />
    </div>
  );
}
